import { VIDEO_PLAY_MESSAGE_TYPE } from "src/lib/native-bridge/native-message.types";
import { postMessageToNative } from "src/lib/native-bridge/post-message-to-native";

interface IPostVideoMessageToNativeParams {
    videoUrl: string;
    title: string;
}

export const postVideoMessageToNative = ({ videoUrl, title }: IPostVideoMessageToNativeParams): boolean => {
    if (!videoUrl) {
        return false;
    }

    return postMessageToNative({ type: VIDEO_PLAY_MESSAGE_TYPE, videoUrl, title });
};
